import { Component } from '@angular/core';
import { NavParams } from '@ionic/angular';

import { AuthService } from '../../service/auth.service';
import { EventService } from '../../service/event.service';

@Component({
    selector: 'app-warning-modal',
    templateUrl: './warning-modal.page.html',
    styleUrls: ['./warning-modal.page.scss'],
})
export class WarningModalPage
{
    private title = "";
    private message = "";

    constructor(
        private navParams: NavParams,
        private auth: AuthService,
        private event: EventService
    )
    {
    }

    async ngOnInit()
    {
        this.event.modal_subject.next({key: "modalSubscribe", id: 'warning-modal', value: null});
        this.title = this.navParams.data.title;
        this.message = this.navParams.data.message;
    }

    warningClose()
    {
        this.event.modal_subject.next({key: "closeModal", id: 'warning-modal', value: null});
    }
}
